// extracted by mini-css-extract-plugin
export var content = "videobackground-module--content--M-1Mp";
export var ctaText = "videobackground-module--ctaText--lpVME";
export var mainContainer = "videobackground-module--mainContainer--UOuKA";
export var myBtn = "videobackground-module--myBtn--6+1qT";
export var myVideo = "videobackground-module--myVideo--rvQD6";